export const ADD_TASK_DETAILS = {
  TASK_TYPE: "taskType",
  TASK_TITLE: "taskTitle",
  SEARCH_BY_PATIENT: "searchByPatient",
  ASSIGN_TO: "assignTo",
  ASSIGN_BY: "assignBy",
  STATUS: "status",
  TASK_DESCRIPTION: "taskDescription",
  DUE_DATE: "dueDate",
};
export const TYPE_OF_RELATION = [
  { label: "Pending", value: "pending" },
  { label: "Completed", value: "completed" },
  { label: "In Progress", value: "in-progress" },
];

export const TASK_TYPE = [
  { label: "Health Checkup", value: "healthCheckup" },
  { label: "Follow-Up Appointment", value: "followUpAppointment" },
  { label: "Specialist Referral", value: "specialistReferral" },
  { label: "Counseling Session", value: "counselingSession" },
  { label: "Self-Care Guidance", value: "selfCareGuidance" },
  { label: "Nursing Care Assistance", value: "nursingCareAssistance" },
  { label: "Incident Reporting", value: "incidentReporting" },
  { label: "Camp Resource Allocation", value: "campResourceAllocation" },
  { label: "Documentation Review", value: "documentationReview" },
  { label: "Staff Coordination", value: "staffCoordination" },
  { label: "Provider Consultation", value: "providerConsultation" },
  {
    label: "Inter-Department Communication",
    value: "interDepartmentCommunication",
  },
  { label: "Emergency Response", value: "emergencyResponse" },
  {
    label: "Workshop/Activity Management",
    value: "workshopActivityManagement",
  },
  { label: "Camp Setup/Teardown", value: "campSetupTeardown" },
];

export const STATUS_FOR_TASK = [
  { label: "Pending", value: "pending" },
  { label: "In Progress", value: "inProgress" },
  { label: "Completed", value: "completed" },
  { label: "In Review", value: "InReview" },
];

// Filter-only status list (adds "Not Completed" — a filter pseudo-status, not a
// settable task status, so it's kept out of STATUS_FOR_TASK used by Add/Edit).
export const STATUS_FILTER_FOR_TASK = [
  ...STATUS_FOR_TASK,
  { label: "Not Completed", value: "NotCompleted" },
];

// ROLE_BASED_REMOVED (pre-Jamboree): restore to re-enable role assignment.
// USER_TYPE_OPTIONS was unused anywhere in the app.
// export const USER_TYPE_OPTIONS = [
//   { label: "Individuals", value: "individuals" },
//   { label: "Groups", value: "groups" },
//   { label: "Role Based", value: "roleBased" },
// ];

  // ROLE_BASED_REMOVED (pre-Jamboree): restore to re-enable role assignment.
  // Static data for Role Based assignments — was imported but never used;
  // roles actually come from getAssignToList({ type: "role_based" }).
  // export const roleBasedOptions = [
  //   { label: "Doctor", value: "doctor" },
  //   { label: "Nurse", value: "nurse" },
  //   { label: "Administrator", value: "administrator" },
  //   { label: "Technician", value: "technician" },
  //   { label: "Pharmacist", value: "pharmacist" },
  //   { label: "Lab Technician", value: "lab_technician" },
  //   { label: "Radiologist", value: "radiologist" },
  //   { label: "Therapist", value: "therapist" },
  // ];

  // Assign To category options
  export const assignToCategoryOptions = [
    { label: "Individuals", value: "individuals" },
    { label: "Groups", value: "groups" },
    // ROLE_BASED_REMOVED (pre-Jamboree): restore to re-enable role assignment.
    // { label: "Role Based", value: "role_based" },
  ];
